import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { homeMaterials } from "../data/site";
import { Seo, breadcrumbLd } from "../components/Seo";
import { PageHero, CTABand } from "../components/ui-blocks";

const Materials = () => {
  return (
    <div>
      <Seo
        title="Materials — Granite, Quartz & Natural Stone"
        description="Explore the stone surfaces we fabricate and install: granite, quartz and natural stone. Learn about appearance, applications and care."
        path="/materials"
        jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "Materials", path: "/materials" }])}
      />
      <PageHero
        eyebrow="Materials"
        title="A Showroom of Surfaces"
        subtitle="Every material has its own character, performance and care. Explore the options we work with and find the right fit for your project."
        image={homeMaterials[2].image}
        testid="materials-hero"
      />

      <section className="section bg-white">
        <div className="container-custom grid md:grid-cols-3 gap-8">
          {homeMaterials.map((m) => (
            <Link key={m.slug} to={`/materials/${m.slug}`} className="card-flat group" data-testid={`materials-card-${m.slug}`}>
              <div className="img-zoom h-64 overflow-hidden">
                <img src={m.image} alt={m.name} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="p-6">
                <h2 className="text-2xl mb-2">{m.name}</h2>
                <p className="text-neutral-600 text-sm mb-4">{m.blurb}</p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-[#CD1422]">
                  View {m.name} <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <CTABand title="Not Sure Which Material Is Right?" copy="Tell us about your space and how you use it — we'll help you compare options and choose a surface you'll love for years." />
    </div>
  );
};

export default Materials;
